export const state = () => ({
  list: []
})

export const mutations = {
  add(state, data) {
    this.state.companies.list = data
  }
}
